// Copy paste this template to create a new component
// that can be put into the masonry layout!

import * as React from "react";
import { css } from "emotion";
import Card from "./Card";
import { defaults, Bar, Line } from "react-chartjs-2";
import { labeledStatement } from "@babel/types";

const barChartOptions = {
  maintainAspectRatio: false,
  responsive: true,
  legend: {
    display: true,
    // align: 'start',
    // onClick: null
  },
  datasets: {
    line: {
      tension: 0,
      fill: false
    }
  },
  scales: {
    xAxes: [
      {
        display: true,
        position: "bottom",
        scaleLabel: {
          display: true,
          labelString: "Year"
        }
      }
    ],
    yAxes: [
      {
        ticks: {
          //set the labels to stack when they're too long
          //so they don't overflow out of the card
          callback: function(label) {
            if (/\s/.test(label)) {
              if (label.split(" ").length > 2) {
                label = label.split(" ");
                label[1] = label[0] + " " + label[1];
                label.shift();
                return label;
              } else {
                return label.split(" ");
              }
            } else {
              return label;
            }
          }
        },
        stacked: false,
        display: true,
        scaleLabel: {
          display: true,
          labelString: "Percent of Students who Identify"
        }
      }
    ]
  },
  title: {
    display: false,
  },
  tooltips:{
    callbacks:{
      label: function(tooltipItem){
        return this._data.datasets[tooltipItem.datasetIndex].label +': ' + tooltipItem.yLabel + '%';
      }
    }
  }
};

interface InternEthnicityProps{
  caption: Array<string>;
}

class InternEthnicityBreakdownBarChartCard extends React.Component<InternEthnicityProps> {
  constructor(props: InternEthnicityProps){
    super(props);
  }
  state = {
    //using this as the data
    //hardcoded
    labels: ["Fall 2019", "Fall 2020", "Fall 2021","Fall 2022"],
    borderWidth: 1,
    datasets: [
      // { data: [1, 31.8, 7.3, 0, 44.3, 0, 11.5, 4.2], backgroundColor: "#48A2D3", label: "Fall 2019" },
      // { data: [1.7, 23.8, 10.4, 0, 48.8, 5.4, 9.2, 0.8], backgroundColor: "#F0A202", label: "Fall 2020" },

      { data: [1, 1.7, 2.9,.99], borderColor: "#48A2D3", backgroundColor: "#48A2D3", label: "Black or African American"},
      { data: [31.8, 23.8, 28.8,21.78], borderColor: "#F0A202", backgroundColor: "#F0A202", label: "White"},
      { data: [7.3, 10.4, 10.8,12.87], borderColor: "#733B90", backgroundColor: "#733B90", label: "Hispanic or Latino"},
      { data: [0, 0, 0.7,0], borderColor: "#EFD50D", backgroundColor: "#EFD50D", label: "Native American or American Indian"},
      { data: [44.3, 48.8, 42.4,43.56], borderColor: "#5DBD5B", backgroundColor: "#5DBD5B", label: "Asian/Pacific Islander"},
      { data: [NaN, 5.4, 6.5,2.97], borderColor: "#0080C6", backgroundColor: "#0080C6", label: "Middle Eastern (not recorded in 2019)"},
      { data: [11.5, 9.2, 7.2,14.85], borderColor: "#C377E0", backgroundColor: "#C377E0", label: "Multiracial"},
      { data: [4.2, 0.8, 0.7,2.97], borderColor: "#E84855", backgroundColor: "#E84855", label: "Prefer not to say"},
    ]
  };
  render() {
    //this.collect_data();
    defaults.global.defaultFontColor = "#0a0a0a";
    const caption = this.props.caption;
    return (
      <Card>
        <div
          className={css`
            font-size: 30px;
            text-align: center;
            margin-bottom: 5px;
            @media (max-width: 700px) {
              font-size: 18px;
            }
          `}
        >
          Interns race/ethnicity breakdown
        </div>
        <div
          className={css`
            height: 600px;
            width: 100%;
          `}
        >
          <Line
            data={this.state}
            options={{
              ...barChartOptions
            }}
          />
        </div>
        <div
          className={css`
            font-size: 15px;
            margin: 10px;
            color: black;
            text-align: left;
          `}
        >
            {caption}
        </div>
      </Card>
    );
  }
}

export default InternEthnicityBreakdownBarChartCard;
